/*
* プロジェクト詳細画面_収益シミュレーション機能
*/

export default class Simulation {
  constructor() {
    this.$simulationTrigger = document.querySelectorAll('[data-target="simulationAccordionTrigger"]');
    this.$targetBtn         = document.getElementById('simulation-button');
    this.$simulationContent = document.getElementById('simulation-content');

    this.$capitalAmount     = document.querySelector('[data-target="displayTotalAmount"]');
    this.$afterTax          = document.querySelector('[data-target="afterTax"]');
    this.$beforeTax         = document.querySelector('[data-target="beforeTax"]');
    this.$tax               = document.querySelector('[data-target="tax"]');
    this.$interest          = document.querySelector('[data-target="interestRate"]');

    this.$numberBoxStepUp   = document.querySelector('[data-target="numberBoxStepUp"]');
    this.$numberBoxStepDown = document.querySelector('[data-target="numberBoxStepDown"]');
    this.$numberBox         = document.querySelector('[data-target="numberBox"]');

    this.$operationStartDate = document.getElementById('operationStartDate');
    this.$operationEndDate   = document.getElementById('operationEndDate');

    this.$WITHHOLDING_TAX_RATE = 0.2042;
  }
  openSimulationAccordion() {
    if(this.$targetBtn == null) {
      return;
    }
    this.$targetBtn.addEventListener('click', () => {
      if(this.$simulationContent.classList.contains('is-open')) {
        this.$simulationContent.classList.remove('is-open');
      } else {
        this.$simulationContent.classList.add('is-open');
      }
    });
  }
  attachEvent() {
    if(this.$simulationTrigger.length == 0) {
      return;
    }
  }
  calculateSimulation() {
    // 出資金額(円) * 利回り * (運用期間 / 年利)
    const trimCapitalAmount  = Number(this.$capitalAmount.textContent.trim().replace('¥', '').replaceAll(',', ''));

    const operationStartDate = this.replaceToDateTimeFormat(this.$operationStartDate);
    const operationEndDate   = this.replaceToDateTimeFormat(this.$operationEndDate);
    const operationTerm      = ((Date.parse(operationEndDate) - Date.parse(operationStartDate)) / (24 * 60 * 60 * 1000)) + 1;

    const profit             = trimCapitalAmount * Number(this.$interest.textContent * 0.01) * (operationTerm / 365);

    // 小数点以下は切り上げ
    const beforeTax          = Math.floor(profit + trimCapitalAmount);
    const tax                = Math.floor(profit * this.$WITHHOLDING_TAX_RATE);
    const afterTax           = Math.floor(beforeTax - tax);

    this.$afterTax.innerText  = '¥' + afterTax.toLocaleString();
    this.$beforeTax.innerText = '¥' + beforeTax.toLocaleString();
    this.$tax.innerText       = '¥' + tax.toLocaleString();
  }
  replaceToDateTimeFormat(targetDate) {
    let operationTargetDate = targetDate.textContent;
    ['年', '月'].map((el) => { operationTargetDate = operationTargetDate.replace(el, '/'); });
    return operationTargetDate.slice(0, -1);
  }
}
